<template>
    <div class="chime-datepicker-wrapper">
        <div class="chime-datepicker-header">
            <i
                class="datepicker-btn prev-prev-btn iconfont icon-more_arrow"
                @click="chooseYearMonth(year - 1, month)"
            ></i>
            <i
                class="datepicker-btn iconfont icon-v3"
                @click="chooseYearMonth(year, month - 1)"
            ></i>
            <p class="title">
                <span class="cursor" @click="openYearPicker">{{ year }}</span> -
                <span class="cursor" @click="openMonthPicker">{{
                    monthSimpleNames[month]
                }}</span>
            </p>
            <a
                class="datepicker-btn iconfont icon-v3-copy"
                @click="chooseYearMonth(year, month + 1)"
                rel="noopener noreferrer"
            ></a>
            <i
                class="datepicker-btn next-next-btn iconfont icon-more_arrow"
                @click="chooseYearMonth(year + 1, month)"
            ></i>
        </div>
        <div class="chime-datepicker-table">
            <table cellpadding="0" cellspacing="0">
                <thead>
                    <tr>
                        <th v-for="wk in weeks" :key="wk">
                            {{ weekNames[wk] }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(week, idx1) in day42" :key="idx1">
                        <td
                            v-for="(day, idx2) in week"
                            :key="[idx1, idx2, day.date].join('-')"
                            :class="{
                                'prev-month': day.isPre,
                                'next-month': day.isNext,
                                available: !day.isPre && !day.isNext,
                                today:
                                    day.year === today.year &&
                                    day.month === today.month &&
                                    day.date == today.date,
                                current:
                                    day.year === current.year &&
                                    day.month === current.month &&
                                    day.date === current.date
                            }"
                            @click="chooseDate(day)"
                        >
                            <div>
                                <span>{{ day.date }}</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import calendar from './calendar';
export default {
    emits: [
        'chooseDate',
        'updateYearMonth',
        'monthUpdate',
        'openYearPicker',
        'openMonthPicker'
    ],
    props: {
        year: Number,
        month: Number,
        today: Object,
        current: Object
    },
    data: function() {
        return {
            day42YM: {}, 
            weeks: [0, 1, 2, 3, 4, 5, 6],
            day42: []
        };
    },
    computed: {
        ...mapState(usePageStore, ['weekNames', 'monthSimpleNames'])
    },
    created() {
        this.get42Day(this.year, this.month);
    },
    methods: {
        chooseDate({ year, month, date }) {
            this.$emit('chooseDate', { year, month, date });
        },
        get42Day(year, month) {
            // Get the dates displayed on the calendar for this month
            if (
                this.day42.length &&
                this.day42YM.year == year &&
                this.day42YM.month == month
            ) {
                return;
            }
            this.day42 = calendar.monthDays(year, month);
            Object.assign(this.day42YM, { year, month });
        },
        chooseYearMonth(year, month) {
            if (month < 0) {
                year--;
                month += 12;
            }
            if (month >= 12) {
                year++;
                month -= 12;
            }
            this.$emit('updateYearMonth', { year, month });
        },
        updateMonth(month) {
            this.$emit('monthUpdate', month);
        },
        openYearPicker() {
            this.$emit('openYearPicker');
        },
        openMonthPicker() {
            this.$emit('openMonthPicker');
        }
    }
};
</script>
<style></style>
